import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { qrService } from '../../services/qrService';
import { Spinner } from '../../components/ui/Spinner';
import { Button } from '../../components/ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export const QrRedirect = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    const resolveQr = async () => {
      try {
        const slug = await qrService.resolveToken(token);
        if (slug) {
          // Pass source tracking context to the public card
          navigate(`/c/${slug}?source=qr_code&token=${token}`, { replace: true });
        } else {
          setError(true);
        }
      } catch (err) {
        setError(true);
      }
    };
    
    if (token) resolveQr();
  }, [token, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-4 text-center">
        <div className="w-16 h-16 bg-slate-200 text-slate-400 rounded-full flex items-center justify-center mb-6">
          <SafeIcon icon={FiIcons.FiLink2} className="text-3xl" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">This Meetoi connection is unavailable</h1>
        <p className="text-slate-600 max-w-md mx-auto mb-8">
          The digital card may be unpublished, archived, or the QR code may no longer be active.
        </p>
        <div className="flex gap-4">
          <Link to="/">
            <Button>Go to Meetoi</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex justify-center items-center bg-slate-50">
      <Spinner size="lg" />
    </div>
  );
};